import { render, staticRenderFns } from "./CoachAvatarList.vue?vue&type=template&id=5ea9d216&scoped=true&lang=pug"
import script from "./CoachAvatarList.vue?vue&type=script&lang=js"
export * from "./CoachAvatarList.vue?vue&type=script&lang=js"
import style0 from "./CoachAvatarList.vue?vue&type=style&index=0&id=5ea9d216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea9d216",
  null
  
)

export default component.exports